import z from "zod";
import * as countries from "country-codes-list";

import type { Address } from "./addresses.types";

export const AddressSchema: z.ZodType<Address> = z
  .object({
    addressName: z.string().min(1, { message: "Address name is required" }),
    streetName: z.string().min(1, { message: "Street name is required" }),
    streetNumber: z.string().min(1, { message: "Street number is required" }),
    postalCode: z.string().min(1, { message: "Postal code is required" }),
    city: z.string().min(1, { message: "City is required" }),
    country: z.enum(countries.all().map(c => c.countryNameEn)),
    details: z.string().optional(),
  })
  .superRefine((data, ctx) => {
    if (
      data.country.toUpperCase() === "FRANCE" &&
      data.postalCode.length !== 5
    ) {
      ctx.addIssue({
        code: "custom",
        message: "Postal code must be 5 characters long for France",
        path: ["postalCode"],
      });
    }

    if (data.streetName.length + data.streetNumber.length > 33) {
      ctx.addIssue({
        code: "custom",
        message: "Street name and number must be at most 33 characters long",
        path: ["streetName", "streetNumber"],
      });
    }
  });
